<template>
  <div class="callback">Logout</div>
</template>

<script>
export default {
    name: 'logout',
    mounted() {
        this.$auth.logout({
        returnTo: window.location.origin
      });
    }
}
</script>